"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Favourite_1 = require("../model/Favourite");

var FavouriteEntityEnum_1 = require("../model/FavouriteEntityEnum");

var FavouriteConverter_1 = require("./FavouriteConverter");
/**
 * Default implementation of FavouriteConverter.
 *
 * @author JMr
 */


var FavouriteConverterImpl =
/*#__PURE__*/
function (_FavouriteConverter_) {
  _inherits(FavouriteConverterImpl, _FavouriteConverter_);

  function FavouriteConverterImpl() {
    _classCallCheck(this, FavouriteConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(FavouriteConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(FavouriteConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new Favourite_1.Favourite(Favourite_1.Favourite.schema.id.valueOf(conversions.documentToClassId(source)), Favourite_1.Favourite.schema.entityId.valueOf(conversions.asObject(source, 'entityId', function (value) {
        return conversions.toClassReferenceId(value);
      })), Favourite_1.Favourite.schema.entity.valueOf(conversions.asEnum(source.entity, FavouriteEntityEnum_1.FavouriteEntityEnum)), Favourite_1.Favourite.schema.userId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        entityId: conversions.toDocumentReferenceId(source.entityId),
        entity: source.entity,
        userId: source.userId
      });
      return result;
    }
  }]);

  return FavouriteConverterImpl;
}(FavouriteConverter_1.FavouriteConverter);

exports.FavouriteConverterImpl = FavouriteConverterImpl;